import $ from 'jquery';
import { showSidebarTab } from '~src/sidebarLegacy';
import { hideCursor } from '~core';
import { modifyState } from '~src/state';

export const stopCloneStamp = () => {
  modifyState('isCloneStampActive', false);
  showSidebarTab('edit-images-ai');
  $('#clone-stamp-container').hide();
  $('#drawing-canvas').fadeOut(() => {
    $('#main-canvas-container').fadeIn();
    $('#canvas').removeClass('locked').show();
    $('#sample').hide();
    hideCursor();
  });
};
